import { atom } from "recoil";
import { readFromLS } from "./util/LocalStrogeService";

export const rsToken = atom({
  key: "rsToken",
  default:
    readFromLS("ControllPanellToken") !== null
      ? readFromLS("ControllPanellToken")
      : "",
});

export const rsUserData = atom({
  key: "rsUserData",
  default:
    readFromLS("ControllPanellUserData") !== null
      ? readFromLS("ControllPanellUserData")
      : "",
});

export const rsActiveMenu = atom({
  key: "rsActiveMenu",
  default: "",
});

export const rsGotoLast = atom({
  key: "rsGotoLast",
  default: false,
});

export const rsProgress = atom({
  key: "rsProgress",
  default: false,
});

export const refreshProductGroup = atom({
  key: "refreshProductGroup",
  default: false,
});

export const rsParentChilds = atom({
  key: "rsParentChilds",
  default: {
    id: null,
    name: "",
    scrolParent: {
      top: 0,
      left: 0,
    },
  },
});

export const rsParentChildsNew = atom({
  key: "rsParentChildsNew",
  default: "",
});

export const rsAddress = atom({
  key: "rsAddress",
  default: false,
});

export const rsScroll = atom({
  key: "rsScroll",
  default: 0,
});

export const rsScrollContent = atom({
  key: "rsScrollContent",
  default: 0,
});

export const rsParentCom = atom({
  key: "rsParentCom",
  default: "",
});

export const rsOrderPrint = atom({
  key: "rsOrderPrint",
  default: "",
});

export const rsOpenDrawer = atom({
  key: "rsOpenDrawer",
  default: false,
});
